
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.75 4c1.671 0 3.225.661 4.406 1.844S28 8.579 28 10.25s-.662 3.255-1.844 4.438l-1.469 1.469a6.25 6.25 0 01-4.438 1.844 6.163 6.163 0 01-2.281-.438l1.625-1.625c.215.038.432.063.656.063a4.276 4.276 0 003.031-1.25l1.469-1.469a4.274 4.274 0 000-6.031c-.804-.805-1.863-1.25-3-1.25s-2.227.444-3.031 1.25L17.249 8.72a4.286 4.286 0 00-1.188 3.688l-1.625 1.625a6.16 6.16 0 01-.438-2.281 6.26 6.26 0 011.844-4.438l1.469-1.469a6.25 6.25 0 014.438-1.844zm-2.469 7.281l1.438 1.438-8 8-1.438-1.438zM11.75 14c.793 0 1.565.153 2.281.438l-1.625 1.625A3.75 3.75 0 0011.75 16a4.276 4.276 0 00-3.031 1.25L7.25 18.719a4.274 4.274 0 000 6.031c.804.805 1.863 1.25 3 1.25s2.227-.444 3.031-1.25l1.469-1.469a4.286 4.286 0 001.188-3.688l1.625-1.625a6.16 6.16 0 01.438 2.281 6.258 6.258 0 01-1.844 4.438l-1.469 1.469C13.507 27.339 11.922 28 10.25 28s-3.225-.661-4.406-1.844C4.662 24.974 4 23.421 4 21.75s.662-3.256 1.844-4.438l1.469-1.469a6.25 6.25 0 014.438-1.844z"}})])
          )
        }
      }
    